<template>
  <v-btn class="primary" @click="onClick($event)" :disabled="disabled">
    <v-icon left>mdi-location-enter</v-icon>
    <span v-if="coinFee > 0">{{ $t("common.buy-in-and-participate") }}</span>
    <span v-else>{{ $t("publicGame.participate") }}</span>
  </v-btn>
</template>

<script>
export default {
  name: "ParticipateButton",
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    coinFee: {
      type: Number,
      required: true,
    },
  },

  methods: {
    onClick: function (event) {
      this.$emit("click", event);
    },
  },
};
</script>